import { render, staticRenderFns } from "./addRate.vue?vue&type=template&id=8799a4e2&scoped=true&"
import script from "./addRate.vue?vue&type=script&lang=js&"
export * from "./addRate.vue?vue&type=script&lang=js&"
import style0 from "./addRate.vue?vue&type=style&index=0&id=8799a4e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8799a4e2",
  null
  
)

export default component.exports